// extracted by mini-css-extract-plugin
module.exports = {"h2":"contact-module--h2--2KYP0","email":"contact-module--email--9VHQF","content":"contact-module--content--3oFQn"};